import Cookies from "js-cookie";

const TokenKey = "lzy_session_token";
const ClientrequestidKey = "user-client-request-id";
const UserInforKey = "vue_admin_template_user_infor";

export function getToken() {
  return Cookies.get(TokenKey);
}

export function setToken(token) {
  return Cookies.set(TokenKey, token, {
    domain: window.DOMAIN_CONFIG.tokenDomain,
  });
}

export function removeToken() {
  return Cookies.remove(TokenKey);
}

export function getUserInfor() {
  return Cookies.get(UserInforKey);
}

export function setUserInfor(userInfor) {
  return Cookies.set(UserInforKey, userInfor);
}

export function removeUserInfor() {
  return Cookies.remove(UserInforKey);
}

export function getClientrequestid() {
  return Cookies.get(ClientrequestidKey);
}

export function setClientrequestid(clientrequestid) {
  return Cookies.set(ClientrequestidKey, clientrequestid, {
    domain: window.DOMAIN_CONFIG.tokenDomain,
  });
}

export function removeClientrequestid() {
  return Cookies.remove(ClientrequestidKey);
}
